import { gql } from 'graphql-request';

import {
  TeamAddress,
  TeamCity,
  TeamCreatedAt,
  TeamCurrency,
  TeamDescription,
  TeamDiscount,
  TeamFacebook,
  TeamID,
  TeamImageFile,
  TeamInstagram,
  TeamLinkedIn,
  TeamName,
  TeamNanoID,
  TeamNda,
  TeamOwnerEmail,
  TeamOwnerID,
  TeamOwnerNanoID,
  TeamPreferredPaymentMethod,
  TeamSite,
  TeamSocialNetworks,
  TeamTerms,
  TeamTwitter,
  TeamUpdatedAt,
  TeamUUID
} from '../teamsTypes';

export interface FetchCacheTeamsQueryResponse {
  id: TeamID;
  uuid: TeamUUID;
  nanoId: TeamNanoID;
  name: TeamName;
  description?: TeamDescription;
  city?: TeamCity;
  address?: TeamAddress;
  site?: TeamSite;
  facebook?: TeamFacebook;
  linkedIn?: TeamLinkedIn;
  twitter?: TeamTwitter;
  instagram?: TeamInstagram;
  socialNetworks?: TeamSocialNetworks;
  nda?: TeamNda;
  currency?: TeamCurrency;
  discount?: TeamDiscount;
  createdAt?: TeamCreatedAt;
  updatedAt?: TeamUpdatedAt;
  image?: {
    file: TeamImageFile;
  };
  owner?: {
    id: TeamOwnerID;
    nanoId: TeamOwnerNanoID;
    email: TeamOwnerEmail;
  };
  ownerId?: TeamOwnerID;
  preferredPaymentMethod?: TeamPreferredPaymentMethod;
  terms?: TeamTerms;
}

export const FETCH_CACHE_TEAMS_QUERY = gql`
  query CacheTeams(
    $filters: TeamsFilters
    $sort: [TeamsSortEnum]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    teams(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        nanoId
        name
        description
        city
        address
        site
        facebook
        linkedIn
        twitter
        instagram
        socialNetworks
        nda
        currency
        discount
        createdAt
        updatedAt
        image {
          file
        }
        owner {
          id
          nanoId
          email
        }
        ownerId
        preferredPaymentMethod
        terms
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
